export default __webpack_public_path__ + "static/media/feature-1.b8796cc5.webp";